import React from "react";
import {Tooltip} from "../cms/Tooltip";
import {useTranslation} from "react-i18next";

export const NavButton = (props) => {
    const {t} = useTranslation();
    const isBeta = String(process.env.REACT_APP_IS_BETA).toLowerCase() === 'true';

    if (isBeta && props.id === 'users') {
        return (
            <Tooltip wrapper={'app-nav-li'} content={t('unavailableInBeta')} topOffset={-15}>
                <button className={`app-nav-btn ${props.isActive ? 'nav-active' : ''}`}
                        style={props.isLocked ? {color: '#4A4949', cursor: 'not-allowed'} : {}}
                        onClick={props.onClick}>
                    {props.icon}{props.name}
                </button>
            </Tooltip>

        );
    }

    return (
        <li className={'app-nav-li'}>
            <button className={`app-nav-btn ${props.isActive ? 'nav-active' : ''}`}
                    style={props.isLocked ? {color: '#4A4949', cursor: 'not-allowed'} : {}}
                    onClick={props.onClick}>
                {props.icon}{props.name}
            </button>
        </li>
    );
}